import React, { Component } from "react";
import "./UserCreation.css";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import Axios from "axios";
import { configuration } from "../../appConfig";
import Swal from "sweetalert2";
import Select from "react-select";
import axios from "axios";
import { token } from "../../appTokenConfig";
import adiLogo from "../../assets/img/brand/adi copy.jpg"
// import { search } from 'core-js/fn/symbol';

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export class UserCreation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      words: {},
      lang: "",
      client: "",
      partnerID: "",
      email: "",
      password: "",
      confirmPassword: "",
      noOfScans: "",
      expireDate: this.getCurrentDate(),
      defaultlang: "",
      parentPartnerId: [],
      driveInRegion: "",
      parentPartnerIdArr: [],
      driveInRegionArr: [],
      templates: [],
      langArr: [],
      multiLangArr: [],
      selectedLanguages: [],
      errors: [],
      allUser: [],
      showPassword: false,
      showConfirmPassword: false,
      current_page: null,
      next_page: null,
      previous_page: null,
      modal: false,
      modalActive: false,
      useremail: "",
      userPartnerID: "",
      userPassword: "",
      status: "",
      updatepartnerId: "",
      updateclient: "",
      updateEmail: "",
      showUserUpdatePassword: false,
      showUserUpdateConfirmPassword: false,
      UserUpdatepassword: "",
      UserUpdateconfirmPassword: "",
      UserUpdateexpireDate: "",
      userUpdatedefaultlang: "",
      userUpdatenoOfScans: "",
      userUpdateMultiplelang: [],
      userSelectedLanguages: [],
      recordsPerPage: 10,
      activeTab: "nav-user-creation",
      defaultmultiLangArr: [],
      userUpdatemultiLangArr: [],
      searchStatus: false,
      damageImages: "",
      is_email_authorized: "",
      is_dat: "",
      damageImageUpdate: "",
      isEmailAuthorized: "",
      isDat: "",
      userparentPartnerId: [],
      isVinDuplicate: "",
      isUpdateVinDuplicate: "",
      isInsuranceManagement: "",
      isUpdateInsuranceManagement: "",
      searchThirdPartyUser: "",  // Add search term state
      isThirdParty: [],
      toggleStates: [],
      searchThirdPartyStatus: false,
    };
  }

  componentDidMount() {
    this.getLang();
    this.getTemplates();
    this.getRegions();
    this.getParentPartnerId();
    this.getUser();
    this.getThirdPartyData();
    this.setState({
      activeTab: localStorage.getItem("activeTab") || "nav-user-creation",
    });
  }

  handleSearchChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
    if (e.target.value.trim() === "") {
      this.setState(
        {
          searchThirdPartyStatus: false,
        },
        () => this.getThirdPartyData()
      );
    }
  };

  handleKeyPress = (e) => {
    if (e.key === "Enter") {
      this.getThirdPartyData();  // Call the API on Enter key press
    }
  };

  getThirdPartyData = () => {
    const { searchThirdPartyUser } = this.state;
    const searchQuery = searchThirdPartyUser.trim();  // Trim the search query to avoid empty spaces

    let url = `${configuration.getThirdPartyicon}?search=${searchQuery}`;

    Axios.get(url)
      .then((res) => {
        if (res.data) {
          const isThirdParty = res.data.data;

          const toggleStates = isThirdParty.reduce((acc, user, i) => {
            if (user.third_party_icon && typeof user.third_party_icon === "object") {
              acc[i] = Object.values(user.third_party_icon).map(
                (value) => value === "1"
              );
            } else {
              console.warn(`No valid third_party_icon for user at index ${i}`);
              acc[i] = Array(13).fill(false);  // Default to all toggles off
            }
            return acc;
          }, {});

          this.setState({ isThirdParty, toggleStates, searchThirdPartyStatus: true });
        }
      })
      .catch((err) => {
        console.error("Error fetching third-party data:", err);
      });
  };

  handleToggleChange = (userIndex, toggleIndex) => {
    const { isThirdParty, toggleStates } = this.state;

    if (!isThirdParty[userIndex]) {
      console.warn("User data not available for index:", userIndex);
      return;
    }

    const newToggleStates = { ...toggleStates };
    newToggleStates[userIndex] = [...newToggleStates[userIndex]];
    newToggleStates[userIndex][toggleIndex] = !newToggleStates[userIndex][toggleIndex];

    this.setState({ toggleStates: newToggleStates });

    const toggleTypes = [
      "is_adi", "is_damage_report", "is_dat", "is_dat_calculate", "is_dat_gold",
      "is_dat_ft", "is_solera", "is_email", "is_tyre_analysis", "is_pdr",
      "is_carfax", "is_pdr_mobile", "is_ec2"
    ];

    const updatedUser = { ...isThirdParty[userIndex] };
    updatedUser.third_party_icon[toggleTypes[toggleIndex]] = newToggleStates[userIndex][toggleIndex] ? "1" : "0";

    const updatedisThirdParty = [...isThirdParty];
    updatedisThirdParty[userIndex] = updatedUser;
    this.setState({ isThirdParty: updatedisThirdParty });

    const payload = {
      partner_id: isThirdParty[userIndex].partner_id,
      is_type: toggleTypes[toggleIndex],
      is_show: newToggleStates[userIndex][toggleIndex] ? 1 : 0
    };

    Axios.post(configuration.updateThirdPartyicon, payload)
      .then((res) => {
        if (res.data.status == "true") {
          Toast.fire({
            type: "success",
            title: res.data.message,
          });
        }
      })
      .catch((err) => {
      });
  };

  getCurrentDate() {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    let month = currentDate.getMonth() + 1;
    let day = currentDate.getDate();
    if (month < 10) {
      month = "0" + month;
    }
    if (day < 10) {
      day = "0" + day;
    }
    return `${year}-${month}-${day}`;
  }

  handleTabClick = (tabId) => {
    this.setState({
      activeTab: tabId,
    });
    localStorage.setItem("activeTab", tabId);
  };

  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({ words: res.data, lang: localStorage.getItem("lang") });
    });
  };

  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }

  getRegions = async () => {
    const url = configuration.getDriveInRegion;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    const res = await axios.get(url, { headers });
    if (
      res &&
      res.data &&
      res.data.data &&
      res.data.data.region &&
      res.data.data.region.length > 0
    ) {
      const regionList = res.data.data.region.map((regionName) => {
        return regionName.name;
      });
      this.setState({ driveInRegionArr: regionList });
    }
  };

  getTemplates = (client, key) => {
    let value = client && client.includes("_") ? client : client + `${"_HAIL"}`;
    if (key == "edit") {
      this.setState({
        userSelectedLanguages: [],
        selectedLanguages: [],
      });
    }
    if (key == "getlang") {
      let url = `${configuration.getTemplates}` + "?client=" + value;
      Axios.get(url)
        .then((res) => {
          if (res) {
            this.setState(
              {
                templates: res.data.data,
                langArr: res.data.lang,
              },
              () => {
                if (res.data.lang !== null) {
                  let multiLang =
                    res.data.lang &&
                    res.data.lang.map((item) => {
                      return { value: item, label: item };
                    });
                  this.setState(
                    {
                      userUpdatedefaultlang: multiLang[0],
                      userSelectedLanguages: [...multiLang],
                    },
                    () => {
                      let userEditnewArr = this.state.multiLangArr.filter(
                        (lang) =>
                          lang.value !== this.state.userUpdatedefaultlang.value
                      );
                      let multiLang_2 =
                        userEditnewArr &&
                        userEditnewArr.map((item) => {
                          return item;
                        });
                      this.setState({
                        userUpdatemultiLangArr: [...multiLang_2],
                      });
                      if (this.state.userSelectedLanguages.length > 0) {
                        let newArr_2 = this.state.userSelectedLanguages.filter(
                          (lang) =>
                            lang.value !==
                            this.state.userUpdatedefaultlang.value
                        );
                        let multiLang_3 =
                          newArr_2 &&
                          newArr_2.map((item) => {
                            return item;
                          });
                        this.setState({
                          userSelectedLanguages: [...multiLang_3],
                        });
                      }
                    }
                  );
                }
              }
            );
          }
        })
        .catch((err) => { });
    } else {
      let url = `${configuration.getTemplates}` + "?client=" + "DEFAULT";
      Axios.get(url)
        .then((res) => {
          if (res) {
            this.setState({
              templates: res.data.data,
              langArr: res.data.lang,
            });
            if (res.data.lang !== null) {
              let multiLang =
                res.data.lang &&
                res.data.lang.map((item) => {
                  return { value: item, label: item };
                });
              this.setState(
                {
                  multiLangArr: [...multiLang],
                },
                () => {
                  let userEditnewArr = this.state.multiLangArr.filter(
                    (lang) =>
                      lang.value !== this.state.userUpdatedefaultlang.value
                  );
                  let multiLang_2 =
                    userEditnewArr &&
                    userEditnewArr.map((item) => {
                      return item;
                    });
                  this.setState({
                    userUpdatemultiLangArr: [...multiLang_2],
                  });
                  if (this.state.userSelectedLanguages.length > 0) {
                    let newArr_2 = this.state.userSelectedLanguages.filter(
                      (lang) =>
                        lang.value !== this.state.userUpdatedefaultlang.value
                    );
                    let multiLang_3 =
                      newArr_2 &&
                      newArr_2.map((item) => {
                        return item;
                      });
                    this.setState({
                      userSelectedLanguages: [...multiLang_3],
                    });
                  }
                }
              );
              if (key == "edit") {
                this.setState(
                  {
                    multiLangArr: [...multiLang],
                    defaultlang: multiLang[0],
                    userUpdatedefaultlang: multiLang[0],
                  },
                  () => {
                    let newArr = this.state.multiLangArr.filter(
                      (lang) => lang.value !== this.state.defaultlang.value
                    );
                    let multiLang_1 =
                      newArr &&
                      newArr.map((item) => {
                        return item;
                      });
                    let userEditnewArr = this.state.multiLangArr.filter(
                      (lang) =>
                        lang.value !== this.state.userUpdatedefaultlang.value
                    );
                    let multiLang_2 =
                      userEditnewArr &&
                      userEditnewArr.map((item) => {
                        return item;
                      });
                    this.setState({
                      defaultmultiLangArr: [...multiLang_1],
                      userUpdatemultiLangArr: [...multiLang_2],
                    });
                  }
                );
              }
            }
          }
        })
        .catch((err) => { });
    }
  };

  getParentPartnerId = (e) => {
    let url = `${configuration.getTemplates}` + "?type=" + "partnerIds";
    Axios.get(url)
      .then((res) => {
        if (res) {
          this.setState({
            parentPartnerIdArr: res.data.data,
          });
        }
      })
      .catch((err) => { });
  };

  handleLanguageChange = (selectedOptions) => {
    this.setState({ selectedLanguages: selectedOptions });
  };

  handleDefaultLangChange = (selectedOptions) => {
    this.setState({ defaultlang: selectedOptions }, () => {
      let newArr_1 = this.state.multiLangArr.filter(
        (lang) => lang.value !== this.state.defaultlang.value
      );
      let multiLang_1 =
        newArr_1 &&
        newArr_1.map((item) => {
          return item;
        });
      this.setState({
        defaultmultiLangArr: [...multiLang_1],
      });
      if (this.state.selectedLanguages.length > 0) {
        let newArr_2 = this.state.selectedLanguages.filter(
          (lang) => lang.value !== this.state.defaultlang.value
        );
        let multiLang_2 =
          newArr_2 &&
          newArr_2.map((item) => {
            return item;
          });
        this.setState({
          selectedLanguages: [...multiLang_2],
        });
      }
    });
  };

  handleuserupdateLangChange = (selectedOptions) => {
    this.setState({ userUpdatedefaultlang: selectedOptions }, () => {
      let userEditnewArr = this.state.multiLangArr.filter(
        (lang) => lang.value !== this.state.userUpdatedefaultlang.value
      );
      let multiLang_2 =
        userEditnewArr &&
        userEditnewArr.map((item) => {
          return item;
        });
      this.setState({
        userUpdatemultiLangArr: [...multiLang_2],
      });
      if (this.state.userSelectedLanguages.length > 0) {
        let newArr_2 = this.state.userSelectedLanguages.filter(
          (lang) => lang.value !== this.state.userUpdatedefaultlang.value
        );
        let multiLang_3 =
          newArr_2 &&
          newArr_2.map((item) => {
            return item;
          });
        this.setState({
          userSelectedLanguages: [...multiLang_3],
        });
      }
    });
  };
  handleuserLangChange = (selectedOptions) => {
    this.setState({ userSelectedLanguages: selectedOptions });
  };
  onChange = (event) => {
    const { name, value } = event.target;
    const trimmedValue = value.trim();
    this.setState({ [name]: trimmedValue });
  };

  handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  togglePasswordVisibility = (e, key) => {
    e.preventDefault();
    this.setState((prevState) => ({
      [key]: !prevState[key],
    }));
  };

  onSubmit = async (e) => {
    e.preventDefault();
    const {
      partnerID,
      email,
      password,
      confirmPassword,
      client,
      defaultlang,
      selectedLanguages,
      expireDate,
      noOfScans,
      parentPartnerId,
      driveInRegion,
      damageImages,
      is_dat,
      is_email_authorized,
      isVinDuplicate,
      isInsuranceManagement
    } = this.state;

    const valuesArray = selectedLanguages.map((item) => item.value);
    let arrayFromObject = [defaultlang.value];
    const Array = arrayFromObject.map((item) => item);
    let newArray = valuesArray.length == 0 ? Array : valuesArray;
    var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const errors = [];

    if (partnerID === "") {
      errors.push("PartnerID is required.");
    }
    if (email === "") {
      errors.push("Email is required.");
    }
    if (!emailPattern.test(email)) {
      errors.push("Please enter a valid email address.");
    }
    if (client === "") {
      errors.push("Template is required.");
    }
    if (password === "") {
      errors.push("Password is required.");
    }
    if (client === "") {
      errors.push("Template is required.");
    }
    // if (driveInRegion === "") {
    //   errors.push("Region is required.");
    // }
    if (confirmPassword === "") {
      errors.push("Confirm Password is required.");
    } else if (password !== confirmPassword) {
      errors.push("Passwords do not match.");
    }

    if (expireDate === "") {
      errors.push("Date is required.");
    }
    // if (selectedLanguages.length === 0) {
    //   errors.push("selected Languages is required.");
    // }
    if (defaultlang.value === 0) {
      errors.push("defaultlang Languages is required.");
    }
    if (noOfScans === "") {
      errors.push("Scan Limit is required.");
    }

    if (errors.length) {
      this.setState({
        errors: errors,
      });
    } else {
      this.setState({
        errors: [],
      });

      let payload = {
        partnerId: partnerID,
        email: email,
        password: password,
        confirm_password: confirmPassword,
        template: client,
        default_lang: defaultlang.value,
        // languages: valuesArray,
        languages: newArray,
        expDate: expireDate,
        noOfScans: noOfScans,
        parentPartnerId: parentPartnerId,
        drivein_region: driveInRegion,
        is_damage_image: damageImages == "Yes" ? 1 : 0,
        is_email_authorized: is_email_authorized == "Yes" ? 1 : 0,
        is_dat: is_dat == "Yes" ? 1 : 0,
        is_vin_duplicate: isVinDuplicate == "Yes" ? 1 : 0,
        is_show_insurance: isInsuranceManagement == "Yes" ? 1 : 0,
      };
      Axios.post(configuration.createUser, payload)
        .then((res) => {
          if (res.data.success == true) {
            Toast.fire({
              type: "success",
              title: `${partnerID} created successfully.`,
            });
            this.setState(
              {
                activeTab: "nav-view-user",
              },
              () => {
                localStorage.setItem("activeTab", "nav-view-user");
              }
            );
            window.location.reload();
          } else if (res.data.success == false && res.data.status == 400) {
            Toast.fire({
              type: "error",
              title: `${partnerID} already exists.`,
            });
          }
          if (res.data.error.validation_errors) {
            const errors = Object.values(res.data.error.validation_errors);
            let err_msg = "";
            errors.map((item) => {
              err_msg += item;
            });
            Toast.fire({
              type: "error",
              title: err_msg,
            });
          }
        })
        .catch((err) => { });
    }
  };
  getUser = (page = 1, searchValue = "", recordsPerPage = 10) => {
    let url = `${configuration.getUser}?page=${page}`;

    if (searchValue) {
      url += `&search=${searchValue}`;
    }
    if (recordsPerPage !== 10) {
      url += `&records_per_page=${recordsPerPage}`;
    }

    const partnerId = localStorage.getItem("partnerId");
    if (partnerId) {
      Axios.get(url)
        .then((res) => {
          if (res && res.data) {
            this.setState({
              current_page: res.data.current_page,
              next_page: res.data.next_page,
              previous_page: res.data.previous_page,
              recordsPerPage: res.data.records_per_page,
              total_no_of_pages: res.data.total_no_of_pages,
              total_records: res.data.total_records,
              allUser: res.data.data,
              searchStatus: searchValue !== "",
            });
          }
        })
        .catch((err) => {
          console.error(err);
          this.setState({
            allUser: [],
            searchStatus: true,
          });
        });
    } else {
      this.props.history.push("/login");
    }
  };

  handleStatusChange = (order, status) => {
    this.setState({
      modalActive: true,
      userPartnerID: order.partnerId,
      useremail: order.email,
      status: status,
    });
  };
  // deleteUser = (partnerId) => {
  //   const url = configuration.deleteUser
  //   const payload = {
  //     partnerId: partnerId
  //   }
  //   Axios.post(url, payload).then((res) => {
  //     Toast.fire({
  //       type: "success",
  //       title: "User delete successfully",
  //     });
  //     this.getUser("1")
  //   });
  // }

  deleteUser = (partnerId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085D6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.value) {
        const url = configuration.deleteUser;
        const payload = { partnerId: partnerId };
        Axios.post(url, payload).then((res) => {
          Swal.fire("Deleted!", "User has been deleted.", "success");
          this.getUser("1");
        });
      }
    });
  };
  handlChange = (event) => {
    const { name, value } = event.target;
    const trimmedValue = value.trim();
    this.setState({ [name]: trimmedValue });
  };

  userSubmit = async (e) => {
    e.preventDefault();
    const { userPartnerID, useremail, userPassword, status, current_page } =
      this.state;
    const errors = [];

    if (userPassword.trim() === "") {
      errors.push("Password required.");
    }

    if (errors.length) {
      this.setState({
        errors: errors,
      });
    } else {
      this.setState({
        errors: [],
      });

      let payload = {
        partnerId: userPartnerID,
        email: useremail,
        password: userPassword.trim(),
        action: status,
      };
      Axios.post(configuration.activeDeactiveUser, payload)
        .then((res) => {
          if (res.data.success == true) {
            this.setState({
              modalActive: false,
              userPassword: "",
            });
            this.getUser(current_page);
            const status = res.data.message;
            Toast.fire({
              type: "success",
              title: status,
            });
            window.location.reload();
          }
          if (res.data.status === 400) {
            errors.push("The password has been entered incorrectly.");
            if (errors.length) {
              this.setState({
                errors: errors,
              });
            }
            this.getUser(current_page);
            this.setState({
              modalActive: true,
              userPassword: "",
            });
          }
        })
        .catch((err) => { });
    }
  };

  handleclick = (order) => {
    let langObject = { value: order.default_lang, label: order.default_lang };
    if (order.languages) {
      this.getTemplates(order.client);
      let multiLang =
        order.languages &&
        order.languages.map((item) => {
          return { value: item, label: item };
        });
      this.setState({
        userSelectedLanguages: [...multiLang],
      });
    } else {
      this.getTemplates(order.client, "getlang");
      this.setState({
        userSelectedLanguages: [],
      });
    }
    this.setState({
      modal: true,
      updateEmail: order.email,
      updateclient: order.client,
      updatepartnerId: order.partnerId,
      UserUpdateexpireDate: order.expDate,
      userUpdatedefaultlang: langObject,
      userUpdatenoOfScans: order.scan_limit,
      userparentPartnerId:
        order.parent_partnerId.length > 0 &&
          order.parent_partnerId[0] != "" &&
          order.parent_partnerId[0] != null
          ? order.parent_partnerId
          : [],
      driveInRegion: order.drivein_region,
      damageImageUpdate: order.is_damage_image == "0" ? "No" : "Yes",
      isEmailAuthorized: order.is_email_authorized == "0" ? "No" : "Yes",
      isDat: order.is_dat == "0" ? "No" : "Yes",
      isUpdateVinDuplicate: order.is_vin_duplicate == "0" ? "No" : "Yes",
      isUpdateInsuranceManagement: order.is_show_insurance == "0" ? "No" : "Yes",
    });
  };

  handlupdateUserChange = (event) => {
    const { name, value } = event.target;
    const trimmedValue = value.trim();
    this.setState({ [name]: trimmedValue });
  };

  updateUser = (e) => {
    e.preventDefault();
    const {
      updatepartnerId,
      updateclient,
      updateEmail,
      UserUpdatepassword,
      UserUpdateconfirmPassword,
      current_page,
      UserUpdateexpireDate,
      userUpdatedefaultlang,
      userUpdatenoOfScans,
      userSelectedLanguages,
      userparentPartnerId,
      driveInRegion,
      damageImageUpdate,
      isEmailAuthorized,
      isDat,
      isUpdateVinDuplicate,
      isUpdateInsuranceManagement
    } = this.state;

    const valuesArray = userSelectedLanguages.map((item) => item.value);
    let arrayFromObject = [userUpdatedefaultlang.value];
    const Array = arrayFromObject.map((item) => item);
    let newArray = valuesArray.length == 0 ? Array : valuesArray;

    var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const errors = [];

    if (updateEmail === "") {
      errors.push("User Email is required.");
    }
    if (!emailPattern.test(updateEmail)) {
      errors.push("User Please enter a valid email address.");
    }
    if (updateclient === "") {
      errors.push("Template is required.");
    }
    // if (driveInRegion === "" || driveInRegion == null || driveInRegion == undefined) {
    //   errors.push("Region is required.");
    // }
    // if (userSelectedLanguages.length === 0) {
    //   errors.push("Lang is required.");
    // }
    if (userUpdatedefaultlang.value === "") {
      errors.push("User Defaultlang Languages is required.");
    }
    // if (UserUpdatepassword === "") {
    //   errors.push("User Password is required.");
    // }

    // if (UserUpdateconfirmPassword === "") {
    //   errors.push("User Confirm Password is required.");
    // }
    else if (UserUpdatepassword !== UserUpdateconfirmPassword) {
      errors.push("User Passwords do not match.");
    }

    if (UserUpdateexpireDate === "") {
      errors.push("User Date is required.");
    }
    if (userUpdatenoOfScans === "") {
      errors.push("User Scan Limit is required.");
    }

    if (errors.length) {
      this.setState({
        errors: errors,
      });
    } else {
      this.setState({
        errors: [],
      });

      let payload = {
        partnerId: updatepartnerId,
        email: updateEmail,
        password: UserUpdatepassword,
        confirm_password: UserUpdateconfirmPassword,
        template: updateclient.includes("_")
          ? updateclient
          : updateclient + `${"_HAIL"}`,
        default_lang: userUpdatedefaultlang.value,
        // languages: valuesArray,
        languages: newArray,
        expDate: UserUpdateexpireDate,
        noOfScans: userUpdatenoOfScans,
        parentPartnerId: userparentPartnerId || [],
        drivein_region: driveInRegion,
        is_damage_image: damageImageUpdate == "Yes" ? 1 : 0,
        is_email_authorized: isEmailAuthorized == "Yes" ? 1 : 0,
        is_dat: isDat == "Yes" ? 1 : 0,
        is_vin_duplicate: isUpdateVinDuplicate == "Yes" ? 1 : 0,
        is_show_insurance: isUpdateInsuranceManagement == "Yes" ? 1 : 0,
      };
      Axios.post(configuration.updateUser, payload)
        .then((res) => {
          if (res.data.status === 200 || res.data.success == true) {
            this.getUser(current_page);
            this.setState({
              modal: false,
              UserUpdatepassword: "",
              UserUpdateconfirmPassword: "",
            });
            Toast.fire({
              type: "success",
              title: `${updatepartnerId} Upadate successfully.`,
            });
            window.location.reload();
          } else if (res.data.status === 400) {
            errors.push("Password is wrong.");
            if (errors.length) {
              this.setState({
                errors: errors,
              });
            }
          }
          if (res.data.error.validation_errors) {
            const errors = Object.values(res.data.error.validation_errors);
            let err_msg = "";
            errors.map((item) => {
              err_msg += item;
            });
            Toast.fire({
              type: "error",
              title: err_msg,
            });
          }
        })
        .catch((err) => {
          this.setState({
            modal: false,
          });
        });
    }
  };
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
    if (e.target.value.trim() === "") {
      this.setState(
        {
          result: [],
          searchStatus: false,
        },
        () => this.getUser("1")
      );
    }
  };
  calculateNewPage = (currentPage, oldRecordsPerPage, newRecordsPerPage) => {
    const currentStartIndex = (currentPage - 1) * oldRecordsPerPage;
    return Math.floor(currentStartIndex / newRecordsPerPage) + 1;
  };
  handleFilterChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value);

    const { current_page, recordsPerPage, searchUser } = this.state;

    const newRecordsPerPage = parseInt(value, 10);
    const newPage = this.calculateNewPage(
      current_page,
      recordsPerPage,
      newRecordsPerPage
    );

    this.setState(
      {
        [name]: newRecordsPerPage,
        current_page: newPage,
      },
      () => {
        this.getUser(newPage, searchUser, newRecordsPerPage);
      }
    );
  };

  handlePartnerIdChange = (selectedOptions) => {
    const selectedpartnerId = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    this.setState({
      userparentPartnerId: selectedpartnerId || [],
    });
  };
  handleCreateParentPartnerId = (selectedOptions) => {
    const selectedpartnerId = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    this.setState({
      parentPartnerId: selectedpartnerId || [],
    });
  };

  render() {
    const {
      partnerID,
      email,
      password,
      confirmPassword,
      templates,
      showPassword,
      showConfirmPassword,
      errors,
      allUser,
      current_page,
      recordsPerPage,
      previous_page,
      next_page,
      useremail,
      userPartnerID,
      userPassword,
      showUserPassword,
      updatepartnerId,
      updateEmail,
      updateclient,
      showUserUpdatePassword,
      showUserUpdateConfirmPassword,
      UserUpdatepassword,
      UserUpdateconfirmPassword,
      expireDate,
      noOfScans,
      parentPartnerId,
      driveInRegion,
      driveInRegionArr,
      defaultlang,
      langArr,
      multiLangArr,
      parentPartnerIdArr,
      UserUpdateexpireDate,
      userUpdatedefaultlang,
      userUpdatenoOfScans,
      userSelectedLanguages,
      userUpdateMultiplelang,
      userparentPartnerId,
      activeTab,
      defaultmultiLangArr,
      userUpdatemultiLangArr,
      searchStatus,
      searchUser,
      isUpdateInsuranceManagement,
      isInsuranceManagement,
      searchThirdPartyUser,
      isThirdParty,
      toggleStates,
      searchThirdPartyStatus
    } = this.state;

    const parentPartnerIdOptions = parentPartnerIdArr.map((item) => ({
      value: item,
      label: item,
    }));
    return (
      <>
        <div className="user_create_wrapper">
          <div className="main_user_profile">
            <div className="container-fluid">
              <div className="justify-content-center row">
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div>
                    <nav>
                      <div className="nav nav-tabs" id="nav-tab" role="tablist">
                        <button
                          className={`nav-link ${activeTab === "nav-user-creation" ? "active" : ""
                            }`}
                          id="nav-user-creation-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#nav-user-creation"
                          type="button"
                          role="tab"
                          aria-controls="nav-user-creation"
                          aria-selected={activeTab === "nav-user-creation"}
                          onClick={() =>
                            this.handleTabClick("nav-user-creation")
                          }
                        >
                          User Creation
                        </button>
                        <button
                          className={`nav-link ${activeTab === "nav-view-user" ? "active" : ""
                            }`}
                          id="nav-view-user-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#nav-view-user"
                          type="button"
                          role="tab"
                          aria-controls="nav-view-user"
                          aria-selected={activeTab === "nav-view-user"}
                          onClick={() => this.handleTabClick("nav-view-user")}
                        >
                          View User
                        </button>
                        <button
                          className={`nav-link ${activeTab === "nav-third-party" ? "active" : ""
                            }`}
                          id="nav-third-party-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#nav-third-party"
                          type="button"
                          role="tab"
                          aria-controls="nav-third-party"
                          aria-selected={activeTab === "nav-third-party"}
                          onClick={() => this.handleTabClick("nav-third-party")}
                        >
                          Third Party
                        </button>
                      </div>
                    </nav>
                  </div>
                  <div className="tab-content">
                    <div
                      className={`tab-pane fade ${activeTab === "nav-user-creation" ? "show active" : ""
                        }`}
                      id="nav-user-creation"
                      role="tabpanel"
                      aria-labelledby="nav-user-creation-tab"
                    >
                      <div>
                        <form>
                          <div className="row p-0">
                            <div className="col-lg-6 col-md-6 col-sm-12">
                              <div className="mb-3 form-group">
                                <label
                                  for="exampleInputEmail1"
                                  className="form-label"
                                >
                                  Partner ID
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="partnerID"
                                  value={partnerID}
                                  onChange={this.onChange}
                                />
                                {errors.includes("PartnerID is required.") && (
                                  <span style={{ color: "red" }}>
                                    {this.lang("PartnerID is required.")}
                                  </span>
                                )}
                              </div>
                            </div>

                            <div className="col-lg-6 col-md-6 col-sm-12">
                              <div className="mb-3 form-group">
                                <label
                                  for="EmailAddressInput"
                                  className="form-label"
                                >
                                  Email Address
                                </label>
                                <input
                                  type="email"
                                  className="form-control"
                                  name="email"
                                  value={email}
                                  onChange={this.onChange}
                                />
                                {errors.includes("Email is required.") && (
                                  <span style={{ color: "red" }}>
                                    {this.lang("Email is required.")}
                                  </span>
                                )}
                                {errors.includes(
                                  "Please enter a valid email address."
                                ) &&
                                  !errors.includes("Email is required.") && (
                                    <span style={{ color: "red" }}>
                                      {this.lang(
                                        "Please enter a valid email address."
                                      )}
                                    </span>
                                  )}
                              </div>
                            </div>

                            <div className="col-lg-6 col-md-6 col-sm-12">
                              <div className="mb-3 form-group">
                                <div className="position-relative">
                                  <label
                                    for="PasswordInput"
                                    className="form-label"
                                  >
                                    Password
                                  </label>
                                  <input
                                    type={showPassword ? "text" : "password"}
                                    className="form-control"
                                    name="password"
                                    value={password}
                                    onChange={this.onChange}
                                    onKeyDown={this.handleKeyDown}
                                  />
                                  <div className="password_button">
                                    <button
                                      className="btn"
                                      onClick={(e) =>
                                        this.togglePasswordVisibility(
                                          e,
                                          "showPassword"
                                        )
                                      }
                                    >
                                      <i
                                        className={`fa ${showPassword
                                            ? "fa-eye"
                                            : "fa-eye-slash"
                                          }`}
                                      ></i>
                                    </button>
                                  </div>
                                </div>
                                {errors.includes("Password is required.") && (
                                  <span style={{ color: "red" }}>
                                    {this.lang("Password is required.")}
                                  </span>
                                )}
                              </div>
                            </div>

                            <div className="col-lg-6 col-md-6 col-sm-12">
                              <div className="mb-3 form-group">
                                <div className="position-relative">
                                  <label
                                    for="ConfirmPasswordInput"
                                    className="form-label"
                                  >
                                    Confirm Password
                                  </label>
                                  <input
                                    type={
                                      showConfirmPassword ? "text" : "password"
                                    }
                                    className="form-control"
                                    name="confirmPassword"
                                    value={confirmPassword}
                                    onChange={this.onChange}
                                    onKeyDown={this.handleKeyDown}
                                  />
                                  <div className="password_button">
                                    <button
                                      className="btn"
                                      onClick={(e) =>
                                        this.togglePasswordVisibility(
                                          e,
                                          "showConfirmPassword"
                                        )
                                      }
                                    >
                                      <i
                                        className={`fa ${showConfirmPassword
                                            ? "fa-eye"
                                            : "fa-eye-slash"
                                          }`}
                                      ></i>
                                    </button>
                                  </div>
                                </div>
                                {errors.includes(
                                  "Confirm Password is required."
                                ) && (
                                    <span style={{ color: "red" }}>
                                      {this.lang("Confirm Password is required.")}
                                    </span>
                                  )}
                                {errors.includes("Passwords do not match.") && (
                                  <span style={{ color: "red" }}>
                                    {this.lang("Passwords do not match.")}
                                  </span>
                                )}
                              </div>
                            </div>

                            <div className="col-lg-6 col-md-6 col-sm-12">
                              <div className="mb-3 form-group">
                                <label
                                  for="disabledSelect"
                                  className="form-label"
                                >
                                  Template
                                </label>
                                <select
                                  className="form-select"
                                  placeholder=""
                                  onChange={(e) => {
                                    const selectedTemplate = e.target.value;
                                    this.setState(
                                      {
                                        client: selectedTemplate,
                                      },
                                      () => {
                                        this.getTemplates(
                                          selectedTemplate,
                                          "edit"
                                        );
                                      }
                                    );
                                  }}
                                  value={this.state.client}
                                  name="client"
                                >
                                  <option> -- Select a template -- </option>
                                  {/* <option value={this.state.client !== '' ? (this.state.client.includes("_") ? this.state.client.replace(/_/g, " - ") : this.state.client) :  "-- Select a template --" }>
                                    {this.state.client.includes("_") ? this.state.client.replace(/_/g, " - ") : this.state.client}
                                  </option> */}
                                  {templates.map((temp, index) => {
                                    return (
                                      <option key={index} value={temp}>
                                        {temp.includes("_")
                                          ? temp.replace(/_/g, " - ")
                                          : temp}
                                      </option>
                                    );
                                  })}
                                </select>
                                {errors.includes("Template is required.") && (
                                  <span style={{ color: "red" }}>
                                    {this.lang("Template is required.")}
                                  </span>
                                )}
                              </div>
                            </div>

                            <div className="col-lg-6 col-md-6 col-sm-12">
                              <div className="mb-3 form-group">
                                <label
                                  for="expireDateInput"
                                  className="form-label"
                                >
                                  Exp Date
                                </label>
                                <input
                                  type="date"
                                  className="form-control"
                                  name="expireDate"
                                  value={expireDate}
                                  onChange={this.onChange}
                                />
                                {errors.includes("Date is required.") && (
                                  <span style={{ color: "red" }}>
                                    {this.lang("Date is required.")}
                                  </span>
                                )}
                              </div>
                            </div>

                            {/* <div className='col-lg-6 col-md-6 col-sm-12'>
                              <div className="mb-3 form-group">
                                <label for="defaultlangInput" className="form-label">Default Lang</label>
                                <select
                                className="form-select"
                                placeholder=""
                                onChange={(e) => {
                                  const selectDefaultlang = e.target.value;
                                  this.setState({
                                    defaultlang: selectDefaultlang
                                  });
                                }}
                                value={defaultlang}
                                name="defaultlang"
                                >
                                  {langArr && langArr.map((lang, index) => {
                                    return <option key={index} value={lang}>{lang}</option>;
                                  })}
                                </select>
                              </div>
                            </div> */}

                            <div className="col-lg-6 col-md-6 col-sm-12 selectmultiplelang defaultlang">
                              <div className="mb-3 form-group">
                                <label
                                  for="defaultlangInput"
                                  className="form-label"
                                >
                                  Default Lang
                                </label>
                                <Select
                                  className=""
                                  placeholder=""
                                  closeMenuOnSelect={true}
                                  // isMulti
                                  options={multiLangArr}
                                  onChange={this.handleDefaultLangChange}
                                  value={this.state.defaultlang}
                                  defaultValue={this.state.defaultlang}
                                />
                                {errors.includes(
                                  "Defaultlang Languages is required."
                                ) && (
                                    <span style={{ color: "red" }}>
                                      {this.lang(
                                        "Defaultlang Languages is required."
                                      )}
                                    </span>
                                  )}
                              </div>
                            </div>

                            <div className="col-lg-6 col-md-6 col-sm-12 selectmultiplelang">
                              <div className="mb-3 form-group">
                                <label
                                  for="selectlangInput"
                                  className="form-label"
                                >
                                  Lang
                                </label>
                                <Select
                                  className=""
                                  placeholder=""
                                  closeMenuOnSelect={false}
                                  isMulti
                                  options={defaultmultiLangArr}
                                  onChange={this.handleLanguageChange}
                                  value={this.state.selectedLanguages}
                                />
                                {/* {errors.includes('selected Languages is required.') && <span style={{color : "red"}}>{this.lang("Lang is required.")}</span>} */}
                              </div>
                            </div>

                            <div className="col-lg-6 col-md-6 col-sm-12">
                              <div className="mb-3 form-group">
                                <label
                                  for="noOfScansInput"
                                  className="form-label"
                                >
                                  Scan Limit
                                </label>
                                <input
                                  type="number"
                                  min="0"
                                  className="form-control"
                                  name="noOfScans"
                                  value={noOfScans}
                                  onChange={this.onChange}
                                />
                                {errors.includes("Scan Limit is required.") && (
                                  <span style={{ color: "red" }}>
                                    {this.lang("Scan Limit is required.")}
                                  </span>
                                )}
                              </div>
                            </div>

                            <div className="col-lg-6 col-md-6 col-sm-12 selectmultiplelang">
                              <div className="mb-3 form-group">
                                <label
                                  for="parentPartnerIdInput"
                                  className="form-label"
                                >
                                  Parent PartnerId
                                </label>
                                <Select
                                  className="form-select"
                                  closeMenuOnSelect={false}
                                  placeholder=""
                                  isMulti
                                  options={parentPartnerIdOptions}
                                  onChange={this.handleCreateParentPartnerId}
                                  value={parentPartnerIdOptions.filter(
                                    (option) =>
                                      Array.isArray(parentPartnerId) &&
                                      parentPartnerId.some(
                                        (selectedId) =>
                                          selectedId === option.value
                                      )
                                  )}
                                  name="parentPartnerId"
                                />
                                {/* <select
                                  className="form-select"
                                  placeholder=""
                                  onChange={(e) => {
                                    const selectedpartnerId = e.target.value;
                                    this.setState({
                                      parentPartnerId: selectedpartnerId,
                                    });
                                  }}
                                  value={parentPartnerId}
                                  name="parentPartnerId"
                                >
                                  <option value="">
                                    {" "}
                                    -- Select a PartnerID --{" "}
                                  </option>
                                  {parentPartnerIdArr.map((item, index) => {
                                    return (
                                      <option key={index} value={item}>
                                        {item}
                                      </option>
                                    );
                                  })}
                                </select> */}
                              </div>
                            </div>

                            <div className="col-lg-4 col-md-6 col-sm-12">
                              <div className="mb-3 form-group">
                                <label
                                  for="parentPartnerIdInput"
                                  className="form-label"
                                >
                                  Drive In Region
                                </label>
                                <select
                                  className="form-select"
                                  placeholder=""
                                  onChange={(e) => {
                                    const selectedRegion = e.target.value;
                                    this.setState({
                                      driveInRegion: selectedRegion,
                                    });
                                  }}
                                  value={driveInRegion}
                                  name="driveInRegion"
                                >
                                  <option value="" disabled>
                                    {" "}
                                    -- Select a Region --{" "}
                                  </option>
                                  {driveInRegionArr.map((item, index) => {
                                    return (
                                      <option key={index} value={item}>
                                        {item}
                                      </option>
                                    );
                                  })}
                                </select>
                                {errors.includes("Region is required.") && (
                                  <span style={{ color: "red" }}>
                                    {this.lang("Region is required.")}
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12">
                              <div className="mb-3 form-group">
                                <label
                                  htmlFor="parentPartnerIdInput"
                                  className="form-label"
                                >
                                  Damage Images
                                </label>
                                <select
                                  className="form-select"
                                  placeholder=""
                                  onChange={(e) => {
                                    const selectedRegion = e.target.value;
                                    this.setState({
                                      damageImages: selectedRegion,
                                    });
                                  }}
                                  value={this.state.damageImages}
                                  name="damageImages"
                                >
                                  <option value="" disabled>-- Please select one -- </option>
                                  {["Yes", "No"].map((item, index) => (
                                    <option key={index} value={item}>
                                      {item}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12">
                              <div className="mb-3 form-group">
                                <label
                                  htmlFor="parentPartnerIdInput"
                                  className="form-label"
                                >
                                  Email Authorize
                                </label>
                                <select
                                  className="form-select"
                                  placeholder=""
                                  onChange={(e) => {
                                    const selectedRegion = e.target.value;
                                    this.setState({
                                      is_email_authorized: selectedRegion,
                                    });
                                  }}
                                  value={this.state.is_email_authorized}
                                  name="is_email_authorized"
                                >
                                  <option value="" disabled>-- Please select one -- </option>
                                  {["Yes", "No"].map((item, index) => (
                                    <option key={index} value={item}>
                                      {item}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12">
                              <div className="mb-3 form-group">
                                <label
                                  htmlFor="parentPartnerIdInput"
                                  className="form-label"
                                >
                                  DAT Credentials
                                </label>
                                <select
                                  className="form-select"
                                  placeholder=""
                                  onChange={(e) => {
                                    const selectedRegion = e.target.value;
                                    this.setState({
                                      is_dat: selectedRegion,
                                    });
                                  }}
                                  value={this.state.is_dat}
                                  name="is_dat"
                                >
                                  <option value="" disabled>-- Please select one -- </option>
                                  {["Yes", "No"].map((item, index) => (
                                    <option key={index} value={item}>
                                      {item}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12">
                              <div className="mb-3 form-group">
                                <label
                                  htmlFor="parentPartnerIdInput"
                                  className="form-label"
                                >
                                  Duplicate Vin
                                </label>
                                <select
                                  className="form-select"
                                  placeholder=""
                                  onChange={(e) => {
                                    const selectedRegion = e.target.value;
                                    this.setState({
                                      isVinDuplicate: selectedRegion,
                                    });
                                  }}
                                  value={this.state.isVinDuplicate}
                                  name="isVinDuplicate"
                                >
                                  <option value="" disabled>-- Please select one -- </option>
                                  {["Yes", "No"].map((item, index) => (
                                    <option key={index} value={item}>
                                      {item}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12">
                              <div className="mb-3 form-group">
                                <label
                                  htmlFor="parentPartnerIdInput"
                                  className="form-label"
                                >
                                  Insurance Management
                                </label>
                                <select
                                  className="form-select"
                                  placeholder=""
                                  onChange={(e) => {
                                    const selectedRegion = e.target.value;
                                    this.setState({
                                      isInsuranceManagement: selectedRegion,
                                    });
                                  }}
                                  value={isInsuranceManagement}
                                  name="isInsuranceManagement"
                                >
                                  <option value="" disabled>-- Please select one -- </option>
                                  {["Yes", "No"].map((item, index) => (
                                    <option key={index} value={item}>
                                      {item}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-lg-12 col-md-12 col-sm-12 text-right">
                              <button
                                className="btn submit_button"
                                onClick={(e) => this.onSubmit(e)}
                              >
                                {this.lang("Submit")}
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>

                    <div
                      className={`tab-pane fade pb-0 ${activeTab === "nav-view-user" ? "show active" : ""
                        }`}
                      id="nav-view-user"
                      role="tabpanel"
                      aria-labelledby="nav-view-user-tab"
                    >
                      <div className="row user_search_main_wrapper p-0 mb-3 justify-content-between">
                        {activeTab === "nav-view-user" && (
                          <>
                            <div className="col-lg-1 col-md-2 col-sm-12 p-0 pr-1">
                              <div className="form-group mb-0">
                                <select
                                  className="form-control"
                                  name="recordsPerPage"
                                  onChange={(e) => this.handleFilterChange(e)}
                                  value={recordsPerPage}
                                >
                                  {[10, 20, 30, 40, 50, 100].map((e) => (
                                    <option>{e}</option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12 p-0 pr-1">
                              <div className="form-group mb-0">
                                <input
                                  type="text"
                                  name="searchUser"
                                  value={this.state.searchUser}
                                  className="form-control"
                                  onChange={(e) => this.handleChange(e)}
                                  onKeyPress={(e) => {
                                    if (e.key === "Enter") {
                                      this.getUser(
                                        "1",
                                        searchUser,
                                        recordsPerPage
                                      );
                                    }
                                  }}
                                  placeholder={this.lang("Search")}
                                />
                              </div>
                              {searchStatus &&
                                searchUser &&
                                searchUser.trim() && (
                                  <button
                                    className="close_button main_close__search"
                                    onClick={() => {
                                      this.setState(
                                        {
                                          searchUser: "",
                                        },
                                        () => this.getUser("1")
                                      );
                                    }}
                                  >
                                    <i className="fa fa-close"></i>
                                  </button>
                                )}
                              <button
                                className="search_icon_button"
                                onClick={() => {
                                  this.getUser("1", searchUser, recordsPerPage);
                                }}
                              >
                                <i className="fa fa-search"></i>
                              </button>
                            </div>
                          </>
                        )}
                      </div>
                      <div>
                        <div className="table-responsive">
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                <th className="text-center">Sr. No</th>
                                <th>Partner ID</th>
                                <th>Email Address</th>
                                <th>Region</th>
                                <th>Template</th>
                                <th>Partner account</th>
                                <th className="text-center">Status</th>
                                <th className="text-center">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {allUser && allUser.length > 0 ? (
                                allUser.map((order, i) => (
                                  <tr
                                    key={i}
                                    className={
                                      order.status === "deactive"
                                        ? "deactive-row"
                                        : ""
                                    }
                                  >
                                    <td className="text-center">
                                      {(current_page - 1) *
                                        (recordsPerPage
                                          ? parseInt(recordsPerPage)
                                          : 10) +
                                        i +
                                        1}
                                    </td>
                                    <td>{order.partnerId}</td>
                                    <td>{order.email}</td>
                                    {/* <td>{order.client}</td> */}
                                    <td style={{ textTransform: "capitalize" }}>
                                      {order.drivein_region
                                        ? order.drivein_region
                                        : "-"}
                                    </td>
                                    <td>
                                      {order.client.includes("_")
                                        ? order.client.replace(/_/g, " - ")
                                        : order.client + `${" - HAIL"}`}
                                    </td>
                                    <td>
                                      <div className="partner_id_listing">
                                        {order.parent_partnerId &&
                                          order.parent_partnerId.length > 0 && (
                                            <>
                                              {order.parent_partnerId.length === 1 ? (
                                                <span>{order.parent_partnerId[0]}</span>
                                              ) : (
                                                order.parent_partnerId.map((id, index) => (
                                                  <span key={index}>
                                                    {id}
                                                    {index < order.parent_partnerId.length - 1 && ''}
                                                  </span>
                                                ))
                                              )}
                                            </>
                                          )
                                        }
                                      </div>
                                    </td>
                                    <td
                                      className={`order-status-row text-center ${order.status === "active"
                                          ? "active"
                                          : "deactive"
                                        }`}
                                    >
                                      {order.status}
                                    </td>
                                    <td>
                                      <div className="text-center">
                                        <button
                                          className="edit_btn"
                                          disabled={order.status === "deactive"}
                                          onClick={() =>
                                            this.handleclick(order)
                                          }
                                        >
                                          <i className="fa fa-pencil"></i>
                                        </button>
                                        <button
                                          className="edit_btn"
                                          onClick={() =>
                                            this.deleteUser(order.partnerId)
                                          }
                                        >
                                          <i className="fa fa-trash"></i>
                                        </button>
                                        {order.status === "active" && (
                                          <button
                                            className="deactive_btn"
                                            onClick={() =>
                                              this.handleStatusChange(
                                                order,
                                                "deactive"
                                              )
                                            }
                                          >
                                            <i className="fa fa-times"></i>
                                          </button>
                                        )}
                                        {order.status === "deactive" && (
                                          <button
                                            className="active_btn"
                                            onClick={() =>
                                              this.handleStatusChange(
                                                order,
                                                "active"
                                              )
                                            }
                                          >
                                            <i className="fa fa-check"></i>
                                          </button>
                                        )}
                                      </div>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan={13}
                                    className="text-center"
                                    ref={(el) => {
                                      if (el) {
                                        el.style.setProperty(
                                          "text-align",
                                          "center",
                                          "important"
                                        );
                                      }
                                    }}
                                  >
                                    {this.lang("No Data Found")}
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>


                        </div>
                      </div>
                      <div className="text-right qr_table_footer">
                        <div className="row justify-content-end">
                          <div className="col-lg-5 col-md-6 col-sm-12">
                            <nav aria-label="Page navigation example">
                              <ul className="pagination justify-content-end">
                                <>
                                  <li className="page-item disabled">
                                    <button
                                      className="btn"
                                      disabled={previous_page === null}
                                      onClick={() =>
                                        this.getUser(
                                          previous_page,
                                          searchUser,
                                          recordsPerPage
                                        )
                                      }
                                    >
                                      <i
                                        className="fa fa-angle-double-left"
                                        aria-hidden="true"
                                      ></i>
                                    </button>
                                  </li>

                                  {previous_page && (
                                    <li className="page-item">
                                      <button
                                        className="btn"
                                        onClick={() =>
                                          this.getUser(
                                            previous_page,
                                            searchUser,
                                            recordsPerPage
                                          )
                                        }
                                      >
                                        {previous_page}
                                      </button>
                                    </li>
                                  )}

                                  <li className="page-item active">
                                    {current_page != undefined ||
                                      current_page != null ? (
                                      <button
                                        className="btn"
                                        onClick={() =>
                                          this.getUser(
                                            current_page,
                                            searchUser,
                                            recordsPerPage
                                          )
                                        }
                                      >
                                        {current_page === null
                                          ? 1
                                          : current_page}
                                      </button>
                                    ) : (
                                      ""
                                    )}
                                  </li>

                                  {next_page && (
                                    <li
                                      className="page-item"
                                      onClick={() =>
                                        this.getUser(
                                          next_page,
                                          searchUser,
                                          recordsPerPage
                                        )
                                      }
                                    >
                                      <button className="btn">
                                        {next_page}
                                      </button>
                                    </li>
                                  )}

                                  <li className="page-item">
                                    <button
                                      className="btn"
                                      disabled={next_page === null}
                                      onClick={() =>
                                        this.getUser(
                                          next_page,
                                          searchUser,
                                          recordsPerPage
                                        )
                                      }
                                    >
                                      <i
                                        className="fa fa-angle-double-right"
                                        aria-hidden="true"
                                      ></i>
                                    </button>
                                  </li>
                                </>
                              </ul>
                            </nav>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Third Party */}
                    <div
                      className={`tab-pane fade pb-0 ${activeTab === "nav-third-party" ? "show active" : ""
                        }`}
                      id="nav-third-party"
                      role="tabpanel"
                      aria-labelledby="nav-third-party-tab"
                    >
                      <div className="row user_search_main_wrapper p-0 mb-3 justify-content-between">
                        {this.state.activeTab === "nav-third-party" && (
                          <>
                            <div className="col-lg-3 col-md-6 col-sm-12 p-0 pr-1">
                              <div className="form-group mb-0">
                                <input
                                  type="text"
                                  name="searchThirdPartyUser"
                                  value={searchThirdPartyUser}
                                  className="form-control"
                                  onChange={(e) => this.handleSearchChange(e)} // Handle input change
                                  onKeyPress={(e) => this.handleKeyPress(e)}    // Trigger API call on Enter key press
                                  placeholder="Search"
                                />
                                {/* Clear search button */}
                                {searchThirdPartyStatus && searchThirdPartyUser.trim() && (
                                  <button
                                    className="close_button main_close__search"
                                    onClick={() => {
                                      this.setState({ searchThirdPartyUser: "" }, this.getThirdPartyData);  // Clear search and fetch all data
                                    }}
                                  >
                                    <i className="fa fa-close"></i>
                                  </button>
                                )}
                                {/* Search button */}
                                <button
                                  className="search_icon_button"
                                  onClick={this.getThirdPartyData} // Trigger search manually
                                >
                                  <i className="fa fa-search"></i>
                                </button>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                      <div className="third_party_table_wrapper">
                        <table className="table table-bordered table-responsive-md third-party-table">
                          <thead>
                            <tr>
                              <th className="text-center">Sr. No</th>
                              <th className="text-center">Partner ID</th>
                              <th className="text-center">Adi <img src={adiLogo} alt="Adi Logo" className="header-logo" /></th>
                              <th className="text-center">Damage Report <img src="../assets/images/VI.png" alt="Damage Report Logo" className="header-logo" /></th>
                              <th className="text-center">{this.lang("dat")} <img src="../assets/images/dat.svg" alt={this.lang("dat")} className="header-logo" /></th>
                              <th className="text-center">{this.lang("dat_calculate")} <img src="../assets/images/DatCalculateExpert.png" alt={this.lang("dat_calculate")} className="header-logo" /></th>
                              <th className="text-center">{this.lang("dat_gold")} <img src="../assets/images/fastrackGold.png" alt={this.lang("dat_gold")} className="header-logo" /></th>
                              <th className="text-center">{this.lang("dat_silver")} <img src="../assets/images/dat-fasttrack-ai.png" alt={this.lang("dat_silver")} className="header-logo" /></th>
                              <th className="text-center">Solera <img src="../assets/images/solera-icon.png" alt="Solera Logo" className="header-logo" /></th>
                              <th className="text-center">Email <img src="../assets/images/mail.png" alt="Email Logo" className="header-logo" /></th>
                              <th className="text-center">Tyre Analysis <img src="../assets/images/tyre_analysis.jpg" alt="Tyre Analysis Logo" className="header-logo" /></th>
                              <th className="text-center">Pdr <img src="../assets/images/pdr.png" alt="Pdr Logo" className="header-logo" /></th>
                              <th className="text-center">Carfax <img src="../assets/images/carfax.jpeg" alt="Carfax Logo" className="header-logo" /></th>
                              <th className="text-center">Pdr Mobile <img src="../assets/images/pdrmobile.jpeg" alt="Pdr Mobile Logo" className="header-logo" /></th>
                              <th className="text-center">ec2 <img src="../assets/images/ec2-icon.png" alt="ec2 Logo" className="header-logo" /></th>
                            </tr>
                          </thead>
                          <tbody>
                            {isThirdParty && isThirdParty.length > 0 ? (
                              isThirdParty.map((order, userIndex) => (
                                <tr key={userIndex}>
                                  <td className="text-center">{userIndex + 1}</td>
                                  <td>{order.partner_id}</td>
                                  {Array.from({ length: 13 }).map((_, toggleIndex) => (
                                    <td key={toggleIndex} className="text-center">
                                      <div>
                                        <input
                                          type="checkbox"
                                          checked={toggleStates[userIndex] ? toggleStates[userIndex][toggleIndex] || false : false}
                                          onChange={() => this.handleToggleChange(userIndex, toggleIndex)}
                                        />
                                        {/* <span className="slider"></span> */}
                                      </div>
                                    </td>
                                  ))}
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={15} className="text-center">No Data Found</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal
          centered={true}
          size="xl"
          isOpen={this.state.modal}
          scrollable
          className="theme_modal_user"
          backdrop="static"
          toggle={() => this.setState({ modal: false })}
        >
          <ModalHeader
            className="p-3"
          >
            Update User
          </ModalHeader>
          <ModalBody>
            <form>
              <div>
                <div className="row p-0">
                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="mb-3 form-group">
                      <label for="exampleInputEmail1" className="form-label">
                        Partner ID
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        disabled
                        name="updatepartnerId"
                        value={updatepartnerId}
                      />
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="mb-3 form-group">
                      <label for="EmailAddressInput" className="form-label">
                        Email Address
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        name="updateEmail"
                        value={updateEmail}
                        onChange={this.handlupdateUserChange}
                      />
                      {errors.includes("User Email is required.") && (
                        <span style={{ color: "red" }}>
                          {this.lang("Email is required.")}
                        </span>
                      )}
                      {errors.includes(
                        "User Please enter a valid email address."
                      ) &&
                        !errors.includes("User Email is required.") && (
                          <span style={{ color: "red" }}>
                            {this.lang("Please enter a valid email address.")}
                          </span>
                        )}
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="mb-3 form-group">
                      <div className="position-relative">
                        <label for="PasswordInput" className="form-label">
                          Password
                        </label>
                        <input
                          type={showUserUpdatePassword ? "text" : "password"}
                          className="form-control"
                          name="UserUpdatepassword"
                          value={UserUpdatepassword}
                          onChange={this.handlupdateUserChange}
                          onKeyDown={this.handleKeyDown}
                        />
                        <div className="password_button">
                          <button
                            className="btn"
                            onClick={(e) =>
                              this.togglePasswordVisibility(
                                e,
                                "showUserUpdatePassword"
                              )
                            }
                          >
                            <i
                              className={`fa ${showUserUpdatePassword
                                  ? "fa-eye"
                                  : "fa-eye-slash"
                                }`}
                            ></i>
                          </button>
                        </div>
                      </div>
                      {/* {errors.includes('User Password is required.') && <span style={{ color: "red" }}>{this.lang("User Password is required.")}</span>} */}
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="mb-3 form-group">
                      <div className="position-relative">
                        <label
                          for="ConfirmPasswordInput"
                          className="form-label"
                        >
                          Confirm Password
                        </label>
                        <input
                          type={
                            showUserUpdateConfirmPassword ? "text" : "password"
                          }
                          className="form-control"
                          name="UserUpdateconfirmPassword"
                          value={UserUpdateconfirmPassword}
                          onChange={this.handlupdateUserChange}
                          onKeyDown={this.handleKeyDown}
                        />
                        <div className="password_button">
                          <button
                            className="btn"
                            onClick={(e) =>
                              this.togglePasswordVisibility(
                                e,
                                "showUserUpdateConfirmPassword"
                              )
                            }
                          >
                            <i
                              className={`fa ${showUserUpdateConfirmPassword
                                  ? "fa-eye"
                                  : "fa-eye-slash"
                                }`}
                            ></i>
                          </button>
                        </div>
                      </div>
                      {/* {errors.includes('User Confirm Password is required.') && <span style={{ color: "red" }}>{this.lang("User Confirm Password is required.")}</span>} */}
                      {errors.includes("User Passwords do not match.") && (
                        <span style={{ color: "red" }}>
                          {this.lang("Passwords do not match.")}
                        </span>
                      )}
                      {errors.includes("Password is wrong.") && (
                        <span style={{ color: "red" }}>
                          {this.lang("Password is wrong.")}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="mb-3 form-group">
                      <label for="disabledSelect" className="form-label">
                        Template
                      </label>
                      <select
                        className="form-select"
                        placeholder=""
                        onChange={(e) => {
                          const selectedTemplate = e.target.value;
                          this.setState(
                            {
                              updateclient: selectedTemplate,
                            },
                            () => {
                              this.getTemplates(selectedTemplate, "edit");
                            }
                          );
                        }}
                        value={
                          updateclient.includes("_")
                            ? updateclient.replace(/_/g, " - ")
                            : updateclient + `${" - HAIL"}`
                        }
                        name="updateclient"
                      >
                        <option
                          value={
                            updateclient.includes("_")
                              ? updateclient.replace(/_/g, " - ")
                              : updateclient + `${" - HAIL"}`
                          }
                        >
                          {updateclient.includes("_")
                            ? updateclient.replace(/_/g, " - ")
                            : updateclient + `${" - HAIL"}`}
                        </option>
                        {templates.map((temp, index) => {
                          return (
                            <option key={index} value={temp}>
                              {temp.includes("_")
                                ? temp.replace(/_/g, " - ")
                                : temp}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="mb-3 form-group">
                      <label for="expireDateInput" className="form-label">
                        Exp Date
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        name="UserUpdateexpireDate"
                        value={UserUpdateexpireDate}
                        onChange={this.handlupdateUserChange}
                      />
                      {errors.includes("User Date is required.") && (
                        <span style={{ color: "red" }}>
                          {this.lang("Date is required.")}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* <div className='col-lg-6 col-md-6 col-sm-12'>
                    <div className="mb-3 form-group">
                      <label for="defaultlangInput" className="form-label">Default Lang</label>
                      <select
                      className="form-select"
                      placeholder=""
                      onChange={(e) => {
                        const selectDefaultlang = e.target.value;
                        this.setState({
                          userUpdatedefaultlang: selectDefaultlang
                        });
                      }}
                      value={userUpdatedefaultlang}
                      name="userUpdatedefaultlang"
                      >
                        {langArr && langArr.map((lang, index) => {
                          return <option key={index} value={lang}>{lang}</option>;
                        })}
                      </select>
                    </div>
                  </div> */}

                  <div className="col-lg-6 col-md-6 col-sm-12 selectmultiplelang defaultlang">
                    <div className="mb-3 form-group">
                      <label for="selectlangInput" className="form-label">
                        Default Lang
                      </label>
                      <Select
                        className=""
                        closeMenuOnSelect={true}
                        placeholder=""
                        // isMulti
                        options={multiLangArr}
                        onChange={this.handleuserupdateLangChange}
                        value={this.state.userUpdatedefaultlang}
                        defaultValue={this.state.userUpdatedefaultlang}
                      />
                      {errors.includes(
                        "User Defaultlang Languages is required."
                      ) && (
                          <span style={{ color: "red" }}>
                            {this.lang("User Defaultlang Languages is required.")}
                          </span>
                        )}
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-6 col-sm-12 selectmultiplelang">
                    <div className="mb-3 form-group">
                      <label for="selectlangInput" className="form-label">
                        Lang
                      </label>
                      <Select
                        className=""
                        closeMenuOnSelect={false}
                        placeholder=""
                        isMulti
                        options={userUpdatemultiLangArr}
                        onChange={this.handleuserLangChange}
                        value={this.state.userSelectedLanguages}
                      />
                      {/* {errors.includes('Lang is required.') && <span style={{color : "red"}}>{this.lang("Lang is required.")}</span>} */}
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="mb-3 form-group">
                      <label for="noOfScansInput" className="form-label">
                        Scan Limit
                      </label>
                      <input
                        type="number"
                        min="0"
                        className="form-control"
                        name="userUpdatenoOfScans"
                        value={userUpdatenoOfScans}
                        onChange={this.handlupdateUserChange}
                      />
                      {errors.includes("User Scan Limit is required.") && (
                        <span style={{ color: "red" }}>
                          {this.lang("Scan Limit is required.")}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-6 col-sm-12 selectmultiplelang">
                    <div className="mb-3 form-group">
                      <label
                        htmlFor="parentPartnerIdInput"
                        className="form-label"
                      >
                        Parent PartnerId
                      </label>
                      <Select
                        className="form-select"
                        closeMenuOnSelect={false}
                        placeholder=""
                        isMulti
                        options={parentPartnerIdOptions}
                        onChange={this.handlePartnerIdChange}
                        value={parentPartnerIdOptions.filter(
                          (option) =>
                            Array.isArray(userparentPartnerId) &&
                            userparentPartnerId.some(
                              (selectedId) => selectedId === option.value
                            )
                        )}
                        name="userparentPartnerId"
                      />
                      {/* <select
                        className="form-select"
                        isMulti
                        placeholder=""
                        onChange={(e) => {
                          const selectedpartnerId = e.target.value;
                          this.setState({
                            userparentPartnerId: selectedpartnerId,
                          });
                        }}
                        value={userparentPartnerId}
                        name="userparentPartnerId"
                      >
                        <option value=""> {this.state.parentPartnerId} </option>
                        {parentPartnerIdArr.map((item, index) => {
                          return <option key={index} value={item}>{item}</option>;
                        })}
                      </select> */}
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="mb-3 form-group">
                      <label for="parentPartnerIdInput" className="form-label">
                        Drive In Region
                      </label>
                      <select
                        className="form-select"
                        placeholder=""
                        onChange={(e) => {
                          const selectedRegion = e.target.value;
                          this.setState({
                            driveInRegion: selectedRegion,
                          });
                        }}
                        value={driveInRegion}
                        name="driveInRegion"
                      >
                        <option value=""> {this.state.driveInRegion} </option>
                        {driveInRegionArr.map((item, index) => {
                          return (
                            <option key={index} value={item}>
                              {item}
                            </option>
                          );
                        })}
                      </select>
                      {errors.includes("Region is required.") && (
                        <span style={{ color: "red" }}>
                          {this.lang("Region is required.")}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="mb-3 form-group">
                      <label
                        htmlFor="parentPartnerIdInput"
                        className="form-label"
                      >
                        Damage Images
                      </label>
                      <select
                        className="form-select"
                        placeholder=""
                        onChange={(e) => {
                          const selectedValue = e.target.value;
                          this.setState({
                            damageImageUpdate: selectedValue,
                          });
                        }}
                        value={this.state.damageImageUpdate}
                        name="damageImageUpdate"
                      >
                        <option value="" disabled>-- Please select one -- </option>
                        {["Yes", "No"].map((item, index) => (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="mb-3 form-group">
                      <label
                        htmlFor="parentPartnerIdInput"
                        className="form-label"
                      >
                        Email Authorize
                      </label>
                      <select
                        className="form-select"
                        placeholder=""
                        onChange={(e) => {
                          const selectedRegion = e.target.value;
                          this.setState({
                            isEmailAuthorized: selectedRegion,
                          });
                        }}
                        value={this.state.isEmailAuthorized}
                        name="isEmailAuthorized"
                      >
                        <option value="" disabled>-- Please select one -- </option>
                        {["Yes", "No"].map((item, index) => (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="mb-3 form-group">
                      <label
                        htmlFor="parentPartnerIdInput"
                        className="form-label"
                      >
                        DAT Credentials
                      </label>
                      <select
                        className="form-select"
                        placeholder=""
                        onChange={(e) => {
                          const selectedRegion = e.target.value;
                          this.setState({
                            isDat: selectedRegion,
                          });
                        }}
                        value={this.state.isDat}
                        name="isDat"
                      >
                        <option value="" disabled>-- Please select one -- </option>
                        {["Yes", "No"].map((item, index) => (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="mb-3 form-group">
                      <label
                        htmlFor="parentPartnerIdInput"
                        className="form-label"
                      >
                        Duplicate Vin
                      </label>
                      <select
                        className="form-select"
                        placeholder=""
                        onChange={(e) => {
                          const selectedRegion = e.target.value;
                          this.setState({
                            isUpdateVinDuplicate: selectedRegion,
                          });
                        }}
                        value={this.state.isUpdateVinDuplicate}
                        name="isUpdateVinDuplicate"
                      >
                        <option value="" disabled>-- Please select one -- </option>
                        {["Yes", "No"].map((item, index) => (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="mb-3 form-group">
                      <label
                        htmlFor="parentPartnerIdInput"
                        className="form-label"
                      >
                        Insurance Management
                      </label>
                      <select
                        className="form-select"
                        placeholder=""
                        onChange={(e) => {
                          const selectedRegion = e.target.value;
                          this.setState({
                            isUpdateInsuranceManagement: selectedRegion,
                          });
                        }}
                        value={isUpdateInsuranceManagement}
                        name="isUpdateInsuranceManagement"
                      >
                        <option value="" disabled>-- Please select one -- </option>
                        {["Yes", "No"].map((item, index) => (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </ModalBody>
          <ModalFooter>
            <div>
              <button
                className="btn btn-md p-2 mr-2 cancel_btn"
                onClick={(e) => {
                  e.preventDefault();
                  this.setState({
                    modal: false,
                    errors: [],
                    UserUpdatepassword: "",
                    UserUpdateconfirmPassword: "",
                  });
                }}
              >
                cancel
              </button>
              <button
                className="btn btn-md p-2 submit_button"
                onClick={(e) => this.updateUser(e)}
              >
                Submit{" "}
              </button>
            </div>
          </ModalFooter>

        </Modal>

        <Modal
          centered={true}
          size="md"
          isOpen={this.state.modalActive}
          className="theme_modal_user"
          backdrop="static"
          toggle={() => this.setState({ modalActive: false })}
        >
          <form>
            <ModalBody>
              <div>
                <div className="row p-0">
                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="mb-3 form-group">
                      <label for="exampleInputEmail1" className="form-label">
                        Partner ID
                      </label>
                      <input
                        type="text"
                        disabled
                        className="form-control"
                        name="userPartnerID"
                        value={userPartnerID}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="mb-3 form-group">
                      <label for="EmailAddressInput" className="form-label">
                        Email Address
                      </label>
                      <input
                        type="email"
                        disabled
                        className="form-control"
                        name="useremail"
                        value={useremail}
                        onChange={this.handlChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="mb-3 form-group">
                      <div className="position-relative">
                        <label for="PasswordInput" className="form-label">
                          Password
                        </label>
                        <input
                          type={showUserPassword ? "text" : "password"}
                          className="form-control"
                          name="userPassword"
                          value={userPassword}
                          onChange={this.handlChange}
                          onKeyDown={this.handleKeyDown}
                        />
                        <div className="password_button">
                          <button
                            className="btn"
                            onClick={(e) =>
                              this.togglePasswordVisibility(
                                e,
                                "showUserPassword"
                              )
                            }
                          >
                            <i
                              className={`fa ${showUserPassword ? "fa-eye" : "fa-eye-slash"
                                }`}
                            ></i>
                          </button>
                        </div>
                      </div>
                      {errors.includes("Password required.") && (
                        <span style={{ color: "red" }}>
                          {this.lang("Password is required.")}
                        </span>
                      )}
                      {errors.includes(
                        "The password has been entered incorrectly."
                      ) && (
                          <span style={{ color: "red" }}>
                            {this.lang(
                              "The password has been entered incorrectly."
                            )}
                          </span>
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <div>
                <button
                  className="btn btn-md p-2 mr-2 cancel_btn"
                  onClick={(e) => {
                    e.preventDefault();
                    this.setState({ modalActive: false, errors: [] });
                  }}
                >
                  cancel
                </button>
                <button
                  className="btn btn-md p-2 submit_button"
                  onClick={(e) => this.userSubmit(e)}
                >
                  {this.state.status}
                </button>
              </div>
            </ModalFooter>
          </form>
        </Modal>
      </>
    );
  }
}

export default UserCreation;
